import React, { useEffect, useState } from 'react'
import { BtnList, RecruitModal, RenewalModal } from './components'


const LabBtn = ({
    history,
    lab,
    labID,
    otherData = false,
    otherModal = false,
    renewalModalClassName,
    onChangeRef,
    onProfileClick,
}) => {
    const [tab, setTab] = useState(null);
    const affiliated_products = lab.master?.affiliated_products;
    const teachingTitle = '使用教學';
    const teachingItems = [
        {
            text: '隨時看線上課',
            id: affiliated_products?.find(i => i.name === '隨時看線上課')?.laboratory.id,
        },
        {
            text: '直播及實體課',
            id: affiliated_products?.find(i => i.name === '直播及實體課')?.laboratory.id,
        },
    ];
    const btnData = [
        {
            title: teachingTitle,
            items: teachingItems.map((item) => ({
                label: item.text,
                link: `/lab/dashboard/${lab.pathname}/${item.id}`,
            })),
        },
        {
            title: '續約',
            items: [
                {
                    label: '續約說明',
                    id: `renewal-instructions${renewalModalClassName ? `-${renewalModalClassName}` : ''}`,
                },
                {
                    label: '續約狀態查詢',
                    onClick: onProfileClick,
                    link: '/profile',
                },
            ],
        },
        {
            title: '募集達人',
            id: 'recruit-modal',
        },
    ];
    const [currBtnData, setCurrBtnData] = useState(btnData);
    const labBtnAlignRight = () => {
        const dashboardTab = document.getElementById('ua-tab');

        setTab(dashboardTab ?? null);
    }

    useEffect(() => {
        let newBtnData = [...btnData];

        const idxTeaching = newBtnData.findIndex((item) => (
            item.title === teachingTitle
        ));
        const updateTeachingItems = (onlineID, offlineID) => {
            if (!onlineID && !offlineID) { return []; }

            const newItems = btnData[idxTeaching].items.filter((_, idx) => {
                if (!onlineID && idx === 0) { return false; }

                if (!offlineID && idx === 1) { return false; }

                return true;
            })

            return newItems;
        }

        if (idxTeaching !== -1) {
            newBtnData[idxTeaching] = {
                ...newBtnData[idxTeaching],
                items: updateTeachingItems(teachingItems[0].id, teachingItems[1].id),
            }
            // newBtnData = newBtnData.filter((item) => (item.items && item.items.length !== 0));

            setCurrBtnData(newBtnData);
        }
    }, [labID, affiliated_products, otherData]);

    useEffect(() => {
        if (otherData) {
            const updateData = [...btnData, otherData];

            setCurrBtnData(updateData);
        }
    }, [otherData])

    useEffect(() => {
        labBtnAlignRight();
    }, [history.location.pathname])

    useEffect(() => {
        window.addEventListener('resize', labBtnAlignRight);

        return () => window.removeEventListener('resize', labBtnAlignRight);
    }, [])
    
    return (
        <div className={`lab-btn-wrap${tab ? '' : ` align-right`}`}>
            <div className='lab-btn'>
                {currBtnData.map((item, key) => (
                    <BtnList
                        history={history}
                        item={item}
                        labID={labID}
                        onChangeRef={onChangeRef}
                        key={key}
                    />
                ))}
            </div>

            <RecruitModal />

            <RenewalModal className={renewalModalClassName} />

            {otherModal && otherModal}
        </div>
    );
}


export { LabBtn }